import React, { useContext } from 'react';
import { CompanyDashboardContextType } from './types';

const CompanyDashboardContext = React.createContext<CompanyDashboardContextType>({} as CompanyDashboardContextType);

const useCompanyDashboardContext = () => useContext(CompanyDashboardContext);

export { useCompanyDashboardContext };
export default CompanyDashboardContext;
